import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import BrandsService from "../../../../service/BrandsService";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import NewBrands from "../NewBrands/NewBrands";

const ListBrands = () => {
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [brand, setBrand] = useState("");

  const [isEdit, setIsEdit] = useState(false);
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");

  const brandsService = new BrandsService();
  const toast = useRef(null);
  const newBrandRef = useRef(null);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoading(true);

        const res = await brandsService.getBrands(localStorage.getItem("__extraconomy_token"));

        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoading(false);
        } else {
          setBrands(res.result);
          setFilteredBrands(res.result);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterByBrand = (brandName) => {
    if (brandName) {
      const filteredData = brands.filter((obj) =>
        obj.description.toLowerCase().includes(brandName.toLowerCase())
      );
      setFilteredBrands([...filteredData]);
    } else {
      setFilteredBrands(brands);
    }
  };

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("brandsRegistered")}</h3>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "justify-content",
          alignItems: "center",
        }}
      >
        <InputText
          className="w-100"
          name="tracking"
          value={brand}
          onChange={(e) => {
            setBrand(e.target.value);
            filterByBrand(e.target.value);
          }}
          placeholder={localeText("searchByBrand")}
        />
      </div>

      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={filteredBrands}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          field="descriptionBrand"
          header={localeText("descriptionBrand")}
          style={{ width: "100%" }}
          body={(brand) => {
            return <span>{brand.description}</span>;
          }}
        />
        <Column
          field="edit"
          header={localeText("edit")}
          style={{ width: "20%" }}
          body={(brand) => {
            return (
              <Button
                icon="pi pi-pencil"
                onClick={() => {
                  setIsEdit(false);
                  setDescription(brand.description);
                  setId(brand.id);
                  setIsEdit(true);

                  setTimeout(() => newBrandRef.current.scrollIntoView({ behavior: "smooth" }), 100);
                }}
                style={{ textSize: "4em" }}
              />
            );
          }}
        />
      </DataTable>
      <div ref={newBrandRef} id="NewCategories">
        {isEdit && <NewBrands descriptionBrand={description} id={id} isEdit={isEdit} />}
      </div>
    </div>
  );
};

export default ListBrands;
